export const CARD_COLORS = [
  { bg: "#FDF6E3", border: "#E8DCC8", shimmer: "rgba(210,180,120,0.18)" },
  { bg: "#FFF8F0", border: "#EDDCC8", shimmer: "rgba(200,160,110,0.18)" },
  { bg: "#F0F7F5", border: "#C8DDD8", shimmer: "rgba(140,190,175,0.18)" },
  { bg: "#FFFDF7", border: "#E5DFCF", shimmer: "rgba(195,180,140,0.18)" },
];
